'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
module.exports = function SplittableModel() {
	const self = observable(this);
	let current;
	self.register = function (sidebarOption, sideBarSize) {
		if (self['toggle' + sidebarOption]) {
			throw 'Cannot re-register ' + sidebarOption;
		}
		self['toggle' + sidebarOption] = function () {
			if (current === sidebarOption) {
				self.hide();
			} else {
				current = sidebarOption;
				self.dispatchEvent('show', sidebarOption, sideBarSize);
			}
		};

		self['show' + sidebarOption] = function () {
			if (current !== sidebarOption) {
				current = sidebarOption;
				self.dispatchEvent('show', sidebarOption, sideBarSize);
			}
		};

		self.dispatchEvent('registered', sidebarOption);
	};
	self.hide = function () {
		current = false;
		self.dispatchEvent('hide');
	};
};
